import { Flex } from '@gmg/gmg-react-components';
import { FunctionComponent, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface TemplateProps {
    organizationName: string;
    children?: ReactNode;
}

const JoinOrganizationTemplate: FunctionComponent<TemplateProps> = (props) => {

    const { t } = useTranslation();

    return (
        <Flex
            maxWidth="880px"
            justifyContent="flex-start"
            alignItems="center"
            flexDirection="column"
            height="300px">
            <h1>{t('JoinOrganization.title', {
                defaultValue: 'Welcome to the organization {{organizationName}}',
                organizationName: props.organizationName,
            },
            )}</h1>
            <DividerLine />
            <Description className="px16_400_normal">
                <Trans t={t} i18nKey={'JoinOrganization.agreement'}>
                    By joining an organization, you agree to GMG GmbH`s
                    <a href="https://gmgcolor.com/terms-conditions"
                        target="_blank"
                        rel="noreferrer">
                        Terms and Conditions
                    </a>
                    <a href="https://gmgcolor.com/software-privacy"
                        target="_blank"
                        rel="noreferrer">

                        Privacy Policy
                    </a>.
                </Trans>
            </Description>
            {props.children}
        </Flex>
    );
};

const DividerLine = styled.hr`
    margin: 24px 0;
    border: none;
    height: 1px;
    width: 100%;
    background-color: ${props => props.theme.colors.greyContrastSemiLower};
`;

const Description = styled.p`
    margin: 0;
`;

export default JoinOrganizationTemplate;